/**
 * Created by Denis Kuzin on 15 february 2022
 */

const ClansTopTab = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.setContentSize2(options.width, options.height);

        this.createTableBg();
        this.createTable();
    },

    createTableBg: function () {
        const styles = cleverapps.styles.ClansTopTab;

        const rect = cc.rectSubPadding(cc.rect(0, 0, this.width, this.height), cc.padding(styles.padding));

        const tableBg = this.tableBg = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        tableBg.setContentSize2(rect.width, rect.height);
        tableBg.setAnchorPoint(0, 0);
        tableBg.setAlignment(rect.x, rect.y);
        this.addChild(tableBg);

        const foreground = cleverapps.UI.createScale9Sprite(bundles.clan.frames.table_fg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        foreground.setContentSize2(tableBg.width, tableBg.height);
        foreground.setAnchorPoint(0, 0);
        foreground.setAlignment(0, 0);
        tableBg.addChild(foreground, 1);
    },

    createTable: function () {
        const styles = cleverapps.styles.ClansTopTab.table;

        const rect = cc.rectSubPadding(cc.rect(0, 0, this.tableBg.width, this.tableBg.height), cc.padding(styles.padding));

        const dataSource = StaticDataSource(() => cleverapps.clans.listTop().map((clan, index) => ({
            id: clan.id,
            data: {
                clan,
                place: index + 1,
                player: clan.isUserClan(),
                emblem: clan.emblem,
                name: clan.name
            }
        })));

        const table = new ScrollTable(dataSource, { parentView: this });
        const tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: true
        });

        new TableHandler(table, tableView, {
            id: "topClans",
            height: rect.height,
            rowConstructor: ClansTopRow,
            innerPadding: styles.innerPadding
        });

        tableView.setAlignment(rect.x + rect.width / 2, rect.y + rect.height / 2);
        this.tableBg.addChild(tableView);
    }
});

cleverapps.styles.ClansTopTab = {
    padding: {
        x: -30,
        top: -10,
        bottom: 0
    },

    table: {
        padding: {
            x: 0,
            top: 20,
            bottom: 20
        }
    }
};